import { createContext, useContext } from 'react';

export const CodelistsLoadingContext = createContext<boolean>(false);

export const useCodelistsLoadingContext = () => useContext(CodelistsLoadingContext);
